export default function TestimonialsHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20education%20environment%20with%20diverse%20students%20and%20teachers%20collaborating%20in%20a%20bright%20spacious%20STEM%20classroom%20with%20white%20walls%20and%20natural%20lighting%2C%20featuring%20robotics%20equipment%20and%20digital%20displays%2C%20warm%20and%20inspiring%20atmosphere%20with%20soft%20warm%20tones%20and%20clean%20minimalist%20design%2C%20professional%20corporate%20photography%20style%2C%20high%20quality&width=1920&height=800&seq=testimonials-hero-001&orientation=landscape"
          alt="STEM Education Success Stories"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/90 via-green-800/80 to-green-700/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-8">
          <i className="ri-star-fill text-yellow-400"></i>
          <span className="text-white text-sm font-medium tracking-wide">
            Trusted by Leading Institutions
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
          Success Stories That<br />
          <span className="text-green-300">Inspire Change</span>
        </h1>

        {/* Subheadline */}
        <p className="text-sm md:text-base text-green-100 mb-10 max-w-3xl mx-auto leading-relaxed">
          Discover how schools, colleges, and corporate partners have transformed their STEM education journey with STEMForge Tech Labs — real impact, measurable outcomes, and lasting partnerships.
        </p>

        {/* Quick Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
          {[
            { value: "5,000+", label: "Students Trained" },
            { value: "20+", label: "Workshops Conducted" },
          ].map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-green-200 text-xs">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}